import React from 'react';
import { Paper } from '../../../Paper/Paper';
import { SelectComponents } from '../../types';
import { ExtraOption } from './ExtraOption';
import MenuList from '@mui/material/MenuList';
import { styled } from '../../../../styles';
import { Typography } from '../../../Typography/Typography';
import { useIntlBds } from '../../../../translations/BdsIntlProvider';

export const PaperMuiComponent: NonNullable<SelectComponents['Paper']> = ({
  width,
  minWidth,
  extraItemText,
  onExtraItemClick,
  paperProps,
  elevation,
  showLoadMore
}) => {
  const { children, ...rest } = paperProps;
  const { intl } = useIntlBds();

  return (
    <Paper style={{ width, minWidth }} elevation={elevation} {...rest}>
      {children}
      {!!onExtraItemClick && (
        <MenuList style={{ padding: 0 }}>
          <ExtraOption
            primary={extraItemText ?? '-'}
            data-test="extra-item-click"
            className="MuiAutocomplete-option"
            onMouseDown={onExtraItemClick}
          />
        </MenuList>
      )}
      {showLoadMore && (
        <StyledLoadMoreFooter>
          <Typography variant="body2">{intl.Select.loadMoreHint}</Typography>
        </StyledLoadMoreFooter>
      )}
    </Paper>
  );
};

const StyledLoadMoreFooter = styled('div')`
  padding: 8px 16px 12px 16px;
  border-top: 1px solid ${({ theme }) => theme.tokens.colorSurfaceVariant};

  .MuiTypography-root {
    color: ${({ theme }) => theme.tokens.colorOnSurfaceVariant};
  }
`;
